import React, { useEffect, useReducer, useState } from "react";
import { Breadcrumb, FormGroup, Row, Button, Col, Glyphicon, Checkbox, ControlLabel } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { connect } from "react-redux";
import locale from "../../../../../locale";
import cloneDeep from "lodash.clonedeep";
import Loading from "../../../../Loading";
import { pages, pagesSettingsUpdate } from "../../../../../../api/cp";
import {  } from "@mui/material";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

const ProfileConstructorPage = ({ event }) => {
    const [pageData, setPageData] = useState(null);
    const [pageSettings, updatePageSettings] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        cloneDeep({}),
    );

    useEffect(fetchPageData, []);

    async function fetchPageData() {
        const pagesList = await pages(event.eventKey);
        const profilePage = pagesList?.find(({ type }) => type === 'profile') ?? null;

        if (!!profilePage) {
            setPageData(profilePage)
            updatePageSettings({ ...pageSettings, ...profilePage.settings });
        }
    }

    async function handleUpdateSettings(setting) {
        const formData = new FormData();
        Object.keys(setting).forEach((key) => {
            formData.append(key, setting[key]);
        })
        const response = await pagesSettingsUpdate(pageData.id, formData);
        updatePageSettings({ ...pageSettings, ...response.settings });
    }

    if (!pageData) {
        return <Loading />
    }

    return (
        <section>
            <Row>
                <Breadcrumb>
                    <LinkContainer to={`/event/${event.eventPassword}`}>
                        <Breadcrumb.Item>{locale('mainMenu.event')}</Breadcrumb.Item>
                    </LinkContainer>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Breadcrumb.Item>{locale('mainMenu.pages')}</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.profileConstructor')}</Breadcrumb.Item>
                </Breadcrumb>
            </Row>
            <Row>
                <Col xs={12}>
                    <LinkContainer to={`/event/${event.eventPassword}/pages`}>
                        <Button>
                            <Glyphicon glyph="menu-left" />
                            {' '}
                            {locale('email.back')}
                        </Button>
                    </LinkContainer>
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Col xs={4}>
                        <ControlLabel>{locale('settings.title')}</ControlLabel>
                        <FormGroup>
                            <FormGroup>
                                <FormControlLanguage
                                    type="text"
                                    values={{
                                        ru: pageSettings.titleRu,
                                        en: pageSettings.titleEn,
                                    }}
                                    onChange={{
                                        ru: (e) => updatePageSettings({ titleRu: e.target.value }),
                                        en: (e) => updatePageSettings({ titleEn: e.target.value }),
                                    }}
                                    onBlur={() => handleUpdateSettings({ ...pageSettings, titleRu: pageSettings.titleRu, titleEn: pageSettings.titleEn })}
                                />
                            </FormGroup>
                            <div style={{ display: 'flex', columnGap: '20px', marginTop: '12px' }}>
                                <CPSettingSize
                                    name="titleSize"
                                    label={locale('settings.titleSize')}
                                    eventValue={pageSettings?.titleSize}
                                    defaultValue={'24px'}
                                    onChange={handleUpdateSettings}
                                />
                                <Checkbox
                                    checked={pageSettings.titleBold}
                                    onChange={(e) => handleUpdateSettings({ titleBold: e.target.checked })}
                                >
                                    Bold
                                </Checkbox>
                            </div>
                        </FormGroup>
                </Col>
                <Col xs={8}>
                    <iframe
                        name={pageData?.type + "Page"}
                        src={`/event/${event.eventKey}/profile`}
                        style={{ width: '100%', height: '100dvh' }}
                        frameBorder="0"
                    />
                </Col>
            </Row>
        </section>
    );
};

const mapStateToProps = (store) => ({
    event: store.currentEvent,
});

export default connect(mapStateToProps)(ProfileConstructorPage);
